/**
 * Dynamically intialize the `home-header-slider`'s.
 * It will use the options in the `data-slider-options`.
 */
function msInitializeHomeHeaderSliders() {
    const homeHeaderThumbSlider = new Swiper(`.home-header-thumb-slider`, {
        loop: false,
        loopedSlides: 0,
        slidesPerView: 3,
        spaceBetween: 0,
        breakpoints: {
            "640": { slidesPerView: 3, spaceBetween: 0 },
            "1024": { slidesPerView: 6, spaceBetween: 0}
        },
        autoplay: { delay: 5000 },
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const homeHeaderMainSlider = new Swiper(`.home-header-main-slider`, {
        loop: false,
        loopedSlides: 0,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: { delay: 5000 },
        thumbs: { swiper: homeHeaderThumbSlider },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });
}

document.addEventListener(`DOMContentLoaded`, function() {
    if (document.querySelectorAll('.home-header-main-slider').length) {
        msInitializeHomeHeaderSliders();
    }
});

if (typeof acf !== "undefined") {
    acf.addAction(`render_block_preview`, function($el, attributes) {
        msInitializeHomeHeaderSliders();
    });
}
